//extracted by mini-css-extract-plugin
export default {"resourcesContainer":"styles_resourcesContainer__N4ThP","titleContainer":"styles_titleContainer__x-DWc"};;